"use client";

import InactivityGuard from "@/components/auth/InactivityGuard";

export default function FullWidthPageLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return <InactivityGuard>{children}</InactivityGuard>;
}
